import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import React, { useState } from 'react';

import { CustomerTypeDto } from '@/api/generated';
import { CustomTableEventModel } from '@/components/table/model/CutomTableEvent.model.ts';
import { customTableEventDispatcher } from '@/components/table/util/customTableEventDispatcher.util.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { ProcessAddCustomerDialogCreateCustomerDialog } from '@/views/processesDetails/components/dialog/addCustomer/components/ProcessAddCustomerDialogCreateCustomerDialog.comp.tsx';

export const ProcessAddCustomerDialogButton: React.FC = () => {
  const { t } = useTranslationWithPrefix('views.processesUpdate.dialog.addCustomer');
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [customerType, setCustomerType] = useState<CustomerTypeDto | null>(null);
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setCustomerType(null);
    setIsDialogOpen(false);
  };

  const handleCreateCustomer = (type: CustomerTypeDto) => () => {
    setCustomerType(type);
    handleOpenDialog();
    handleCloseMenu();
  };

  const handleCustomerCreated = (customerName: string) => {
    customTableEventDispatcher(CustomTableEventModel.REFRESH, {
      fullTextSearchInput: customerName,
      ownerIdOfCustomerContact: null,
    });
  };

  return (
    <>
      <Button onClick={handleClick}>{t('button.createCustomer')}</Button>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{
          horizontal: 'left',
          vertical: 'bottom',
        }}
        onClose={handleCloseMenu}
        open={open}
        transformOrigin={{
          horizontal: 'left',
          vertical: 'top',
        }}
      >
        {Object.values(CustomerTypeDto).map(type => (
          <MenuItem key={type} onClick={handleCreateCustomer(type)}>
            {t(`menu.${type}`)}
          </MenuItem>
        ))}
      </Menu>
      {isDialogOpen && customerType && (
        <ProcessAddCustomerDialogCreateCustomerDialog
          customerType={customerType}
          onClose={handleCloseDialog}
          onCreated={handleCustomerCreated}
        />
      )}
    </>
  );
};
